import React, { memo } from "react";
import { NodeProps } from "reactflow";
import { Divider } from "antd";
import styles from "./index.less";
import RenderOutput from "../render/RenderOutput";
import NodeCard from "../NodeCard";
import { FlowModuleItemType } from "@packages/flow-core/module";

const QuestionInputNode = ({
  data,
  selected,
}: NodeProps<FlowModuleItemType>) => {
  const { moduleId, outputs } = data;

  return (
    <NodeCard minWidth={240} selected={selected} {...data}>
      <Divider style={{ margin: 0 }} />
      <div className={styles.content}>
        <RenderOutput moduleId={moduleId} flowOutputList={outputs} />
      </div>
    </NodeCard>
  );
};

export default memo(QuestionInputNode);
